import Login from "../pages/auth/Login"
import Login2FA from "../pages/auth/Login2FA"
export default [
    {path : '/2fa', exact: true, name: "Login", component: Login2FA},
    {path : '/', exact: true, name: "Login", component: Login},
]